import type { WindowService } from './types';

const windowService: WindowService = {
  getLocation: (): Location => {
    return window.location;
  },
};

export default windowService;
